import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";

export const YND_CHOICES = [
  { v: "SI", l: "SÌ" },
  { v: "NO", l: "NO" },
  { v: "NON_APPLICABILE", l: "NON APPLICABILE" },
  { v: "NON_DISPONIBILE", l: "NON DISPONIBILE" },
];

const toStructured = (value) => (value && typeof value === "object" && !Array.isArray(value)
  ? { choice: value.choice || "", description: value.description || "", period: value.period || "" }
  : { choice: "", description: "", period: "" });

// Domande "Sì/No — se sì, quali?": scelta strutturata + descrizione obbligatoria se Sì.
export function YesNoDetailInput({ question, value, onChange, disabled, testid }) {
  const legacyText = typeof value === "string" && value.trim() !== "" ? value : null;
  const v = toStructured(value);
  const isNoLegacy = legacyText && ["no", "no."].includes(legacyText.trim().toLowerCase());
  const set = (patch) => onChange({ ...v, ...patch });

  return (
    <div className="space-y-3" data-testid={testid}>
      {legacyText && (
        <div className="rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900" data-testid={`${testid}-legacy`}>
          Risposta precedente (testo libero): <strong>"{legacyText}"</strong>. Il dato non è stato modificato:
          {isNoLegacy ? " confermalo scegliendo NO oppure" : ""} seleziona un'opzione strutturata qui sotto.
          {isNoLegacy && !disabled && (
            <button type="button" className="ml-2 underline font-semibold" data-testid={`${testid}-convert-no`}
              onClick={() => onChange({ choice: "NO", description: "", period: "" })}>
              Converti in NO
            </button>
          )}
        </div>
      )}
      <div className="flex flex-wrap gap-3" role="radiogroup" aria-label={question.question_text}>
        {YND_CHOICES.map((o) => (
          <button key={o.v} type="button" disabled={disabled}
            onClick={() => set({ choice: o.v })}
            aria-pressed={v.choice === o.v}
            data-testid={`${testid}-${o.v.toLowerCase()}`}
            className={`min-h-[48px] px-5 py-3 rounded-lg border-2 text-sm font-bold transition-colors ${
              v.choice === o.v
                ? "bg-green-700 border-green-700 text-white"
                : "bg-white border-slate-300 text-slate-700 hover:border-green-600"
            }`}>
            {o.l}
          </button>
        ))}
      </div>
      {v.choice === "SI" && (
        <div className="space-y-2" data-testid={`${testid}-detail`}>
          <label className="text-sm font-semibold text-slate-800" htmlFor={`${testid}-description`}>
            Descrizione obbligatoria: cosa è stato fatto o definito? <span className="text-red-700">*</span>
          </label>
          <Textarea id={`${testid}-description`} rows={3} value={v.description} disabled={disabled}
            placeholder="Descrivi in modo sostanziale e pertinente (non basta 'sì')"
            onChange={(e) => set({ description: e.target.value })}
            data-testid={`${testid}-description`} className="text-base" />
          <Input value={v.period} disabled={disabled} placeholder="Periodo / anno di riferimento (es. 2025–2027)"
            onChange={(e) => set({ period: e.target.value })}
            data-testid={`${testid}-period`} className="text-base max-w-sm" />
        </div>
      )}
    </div>
  );
}
